<script>
    import { createEventDispatcher } from 'svelte';
    import { badgesFor } from './itemBadges.js';
    import BadgeRow from './BadgeRow.svelte';
    import GameText from './GameText.svelte';

    export let entry;
    export let view = 'grid';
    export let groupedBy = null;
    export let searching = false;

    const dispatch = createEventDispatcher();

    $: item = entry;
    $: badges = badgesFor(item);

    // Cards view drops the prose for density, but the search index covers it, so a hit
    // would otherwise show a card with nothing on it explaining the match.
    $: showDescription = (view === 'list' || searching) && item.description;

    // The section heading already names the kind when grouped by it, and the card's colour
    // bar carries it visually, so the pill is redundant there.
    $: showKindPill = groupedBy !== 'kind' && item.kind;

    function selectKind() {
        dispatch('selectFacet', { id: 'kind', value: item.kind });
    }
</script>

<div
    class="guide-card kind-{item.kindSlug}"
    class:guide-card--compact={view !== 'list'}>
    <span class="guide-card-bar" aria-hidden="true"></span>
    <div class="guide-card-body">
        <div class="guide-card-head">
            <a
                class="guide-card-name guide-card-link"
                href={`/guides/items/${item.slug}`}
                title={item.description || item.displayName}>{item.displayName}</a>
            {#if showKindPill}
                <button
                    type="button"
                    class="guide-accent-pill guide-accent-pill--button kind-{item.kindSlug}"
                    on:click={selectKind}>
                    {item.kind}
                </button>
            {/if}
        </div>

        {#if showDescription}
            <span class="guide-card-snippet">{item.description}</span>
        {/if}

        <BadgeRow {badges} {view} on:selectFacet />

        {#if item.tags && item.tags.length > 0}
            <span class="guide-card-tags">
                {#each item.tags as tag}
                    <button
                        type="button"
                        class="guide-tag-pill"
                        on:click={() => dispatch('selectFacet', { id: 'tag', value: tag })}>
                        <GameText text={tag} />
                    </button>
                {/each}
            </span>
        {/if}
    </div>
</div>
